import { create } from 'zustand';
import apiClient from '../api/client';
import Alertas from '../alerts/AlertasGernericos';

export const useVendasStore = create((set, get) => ({

    // GETS.
    ano: 0,
    mes_atual: 0,
    toal_vendido: 0,
    carregando: false,
    qtd_de_uso_do_pix: 0,
    qtd_de_uso_do_debito: 0,
    qtd_de_uso_do_credito: 0,
    todas_as_vendas_pix: [],
    todas_as_vendas_debito: [],
    todas_as_vendas_credito: [],
    somatorio_do_meios_de_pagamentos: 0,
    mostrar_grafico_valores_das_vendas: true,
    mostrar_grafico_meios_mais_usados: true,


    // Setters
    setAno: (ano) => set({ ano }),
    setMesAtual: (mes) => set({ mes_atual: mes }),
    setTotalVendido: (valor) => set({ toal_vendido: valor }),
    setCarregando: (valor) => set({ carregando: valor }),
    setQtdPix: (valor) => set({ qtd_de_uso_do_pix: valor }),
    setQtdDebito: (valor) => set({ qtd_de_uso_do_debito: valor }),
    setQtdCredito: (valor) => set({ qtd_de_uso_do_credito: valor }),
    setVendasPix: (vendas) => set({ todas_as_vendas_pix: vendas }),
    setVendasDebito: (vendas) => set({ todas_as_vendas_debito: vendas }),
    setVendasCredito: (vendas) => set({ todas_as_vendas_credito: vendas }),
    setSomatorioMeiosPagamento: (valor) => set({ somatorio_do_meios_de_pagamentos: valor }),
    setMostrarGraficoValores: (valor) => set({ mostrar_grafico_valores_das_vendas: valor }),
    setMostrarGraficoMeiosUsados: (valor) => set({ mostrar_grafico_meios_mais_usados: valor }),


    GetVendas: async () => {
        try {

            set({ carregando: true });

            const response = await apiClient.get('/getPagamentos');

            if (!response) {
                throw new Error("Ocorreu um erro de conexão ao buscar suas vendas, verifique sua conexão.");
            }

            let data = response.data;


            if (data.total == 0) {
                set({ mostrar_grafico_valores_das_vendas: false, })
            }

            if (data.somatorio_do_meios_de_pagamentos == 0) {
                set({ mostrar_grafico_meios_mais_usados: false, })
                return
            }


            set({
                //     O
                //    /|\
                //    / \  
                ano: data.ano,
                carregando: false,
                mes_atual: data.mes,
                toal_vendido: data.total,
                todas_as_vendas_pix: data.pix,
                todas_as_vendas_debito: data.debito,
                todas_as_vendas_credito: data.credito,
                qtd_de_uso_do_pix: data.qtd_de_uso_do_pix,
                qtd_de_uso_do_debito: data.qtd_de_uso_do_debito,
                qtd_de_uso_do_credito: data.qtd_de_uso_do_credito,
                somatorio_do_meios_de_pagamentos: data.somatorio_do_meios_de_pagamentos,
            });

        } catch (err) {
            set({ carregando: false, });
            Alertas.ExibirAlertaErro(err.message || "Erro desconhecido durante o login.");
        } finally {
            set({ carregando: false });
        }
    },

    logout: async () => {
        set({ logado: false });
    },

}));
